import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const ModuleAccessGuard = ({
  moduleKey,
  permittedModules = [],
  isLoading = false,
  children,
}) => {
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando permissões...</span>
        </Spinner>
      </div>
    );
  }

  const hasModuleAccess = permittedModules.some(module => module.key === moduleKey);

  return hasModuleAccess
    ? children
    : <Navigate to="/sem-acesso" replace />;
};

export default ModuleAccessGuard;
